/**
 * Constants for application-wide use
 */

/**
 * Date format configuration for Material date components
 */
export const DISPLAY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY"
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MM/YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM/YYYY"
  }
};
